<template>
  <div>
    <px-view-header title="Responder solicitação" :breadcrumbs="breadcrumbs">
      <template v-slot:before>
        <v-btn class="mb-4 mr-1" icon x-large color="primary" link @click="onClickBack">
          <v-icon>
            mdi-arrow-left
          </v-icon>
        </v-btn>
      </template>
    </px-view-header>
    <div v-if="solicitacao && !loading">
      <px-cotacao-conjunta-resposta-steps :solicitacao="solicitacao"
                                          :editing="editing"
                                          @update="onUpdate" />
    </div>
  </div>
</template>

<script>
import SolicitacaoService from '@/modules/cotacoes/detalhes/solicitacao-service';
import CotacaoConjuntaRespostaSteps from './CotacaoConjuntaRespostaSteps.vue';

export default {
  data() {
    return {
      id: this.$route.params.id,
      idResposta: this.$route.params.idResposta,
      editing: false,
      solicitacao: null,
      loading: false,
      breadcrumbs: [
        { text: 'Negócios' },
        { text: 'Cotações' },
        { text: 'Responder' },
      ],
    };
  },
  methods: {
    onClickBack() {
      this.$router.go(-1);
    },
    onUpdate() {
      this.onClickBack();
    },
    setupImpostos(impostos) {
      return {
        ...impostos,
        icms: impostos.icms ? (impostos.icms * 100).toFixed(2) : 0,
        ipi: impostos.ipi ? (impostos.ipi * 100).toFixed(2) : 0,
      };
    },
    setupEditingPrazos(prazos) {
      if (!prazos) {
        return [];
      }
      return prazos.map((p) => ({
        ...p,
        precoUnitario: p.precoUnitario.toFixed(2),
      }));
    },
    setupEditingProducts() {
      this.solicitacao.respostaCotacaoConjunta.produtos = this.solicitacao.respostaCotacaoConjunta
        .produtos.map((p) => ({
          ...p,
          impostos: this.setupImpostos(p.impostos),
          prazos: this.setupEditingPrazos(p.prazos),
        }));
    },
    setupEditing() {
      this.editing = Boolean(this.idResposta)
        && Number(this.idResposta) === this.solicitacao.respostaCotacaoConjunta.id;

      if (this.editing) {
        if (this.solicitacao.respostaCotacaoConjunta.frete.valorMinimoFreteGratis) {
          this.solicitacao.respostaCotacaoConjunta.frete.valorMinimoFreteGratis = this.solicitacao
            .respostaCotacaoConjunta.frete.valorMinimoFreteGratis.toFixed(2);
        }

        this.setupEditingProducts();
      }
    },
    getSolicitacao() {
      this.loading = true;
      return SolicitacaoService.getSolicitacao(this.id)
        .then((response) => {
          this.solicitacao = response.data;
          this.setupEditing();
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  created() {
    this.getSolicitacao();
  },
  components: {
    pxCotacaoConjuntaRespostaSteps: CotacaoConjuntaRespostaSteps,
  },
};
</script>
